import { Linkedin, Twitter, Github } from "lucide-react"

const navigation = {
  solutions: [
    { name: "Automatización de Procesos", href: "#soluciones" },
    { name: "Integración de Sistemas", href: "#soluciones" },
    { name: "Dashboards en Tiempo Real", href: "#soluciones" },
    { name: "Aplicaciones Web Portátiles", href: "#soluciones" },
  ],
  company: [
    { name: "Sobre Nosotros", href: "#nosotros" },
    { name: "Nuestro Proceso", href: "#proceso" },
    { name: "Contacto", href: "#contacto" },
  ],
  legal: [
    { name: "Política de Privacidad", href: "#" },
    { name: "Términos de Servicio", href: "#" },
    { name: "Cookies", href: "#" },
  ],
  social: [
    { name: "LinkedIn", href: "#", icon: Linkedin },
    { name: "Twitter", href: "#", icon: Twitter },
    { name: "GitHub", href: "#", icon: Github },
  ],
}

export function Footer() {
  return (
    <footer className="bg-background-footer">
      <div className="mx-auto max-w-7xl px-6 py-16 lg:py-24 lg:px-8">
        <div className="grid grid-cols-2 gap-8 lg:grid-cols-4">
          {/* Brand */}
          <div className="col-span-2 lg:col-span-1">
            <a href="/" className="inline-block">
              <img
                src="/hercode-logo.svg"
                alt="Hercode"
                className="h-6 w-auto"
              />
            </a>
            <p className="mt-4 text-sm font-jetbrains font-extralight text-titulo-hero/60 leading-relaxed">
              Transformamos procesos complejos en soluciones simples y automatizadas.
            </p>
            {/* Social links */}
            <div className="mt-6 flex gap-4">
              {navigation.social.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className="text-titulo-hero/60 hover:text-titulo-red transition-colors"
                  aria-label={item.name}
                >
                  <item.icon className="h-5 w-5" />
                </a>
              ))}
            </div>
          </div>

          {/* Solutions */}
          <div>
            <h3 className="text-sm font-work font-semibold text-titulo-hero">Soluciones</h3>
            <ul className="mt-4 space-y-3">
              {navigation.solutions.map((item) => (
                <li key={item.name}>
                  <a
                    href={item.href}
                    className="text-sm font-jetbrains font-extralight text-titulo-hero/60 hover:text-titulo-red transition-colors"
                  >
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-sm font-work font-semibold text-titulo-hero">Empresa</h3>
            <ul className="mt-4 space-y-3">
              {navigation.company.map((item) => (
                <li key={item.name}>
                  <a
                    href={item.href}
                    className="text-sm font-jetbrains font-extralight text-titulo-hero/60 hover:text-titulo-red transition-colors"
                  >
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-sm font-work font-semibold text-titulo-hero">Legal</h3>
            <ul className="mt-4 space-y-3">
              {navigation.legal.map((item) => (
                <li key={item.name}>
                  <a
                    href={item.href}
                    className="text-sm font-jetbrains font-extralight text-titulo-hero/60 hover:text-titulo-red transition-colors"
                  >
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-5 pt-8">
          <p className="text-sm font-jetbrains font-extralight text-titulo-hero/60 text-center">
            © {new Date().getFullYear()} Hercode. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  )
}
